import React from 'react';
import {
  useTransportControllers,
  useCurrencies,
  useCountryInfo,
} from 'react-render-hooks';

type Props = {
  children: React.ReactElement;
};

const HOCInjectLogic = ({ children }: Props) => {
  if (React.isValidElement(children)) {
    return React.cloneElement<any>(children, {
      controllers: useTransportControllers,
      hooks: {
        useCurrencies,
        // : () => [
        //   {
        //     id: 356,
        //     code: 'asd',
        //     name: 'name',
        //     shortView: 'string',
        //   },
        //   {
        //     id: 357,
        //     code: 'asd 1',
        //     name: 'name 2',
        //     shortView: 'string',
        //   },
        // ],
        useCountryInfo,
      },
    });
  }

  return children;
};

export default HOCInjectLogic;
